import {useAtom} from 'jotai'

import {listAtom, listFilterAtom, terminalDetailAtom} from '../store'

export const useTerminal = () => {
  const [list, listSet] = useAtom(listAtom)
  const [listFilter, listFilterSet] = useAtom(listFilterAtom)
  const [detail, detailSet] = useAtom(terminalDetailAtom)

  return {
    list,
    listSet,
    listFilter,
    listFilterSet,
    detail,
    detailSet,
  }
}
